import React from "react";
import "./Navigation.scss";
import { formatNumber } from "../../lib/helpers";

/**
 * Floating navigation
 * @param {Object} props
 * @param {Object} props.income Data entered
 * @param {Object} props.region Selected region
 * @param {Function} props.showIncomeConfiguration Callback for income button
 * @param {Function} props.showRegionConfiguration Callback for region button
 * @returns {React.ReactElement}
 */
function Navigation({
  income,
  region,
  showIncomeConfiguration,
  showRegionConfiguration,
}) {
  return (
    <div className="Navigation">
      <div className="Navigation__items">
        <button
          className="Navigation__button"
          type="button"
          onClick={showIncomeConfiguration}
        >
          {formatNumber(income.incomeSalary)}
        </button>

        <button
          className="Navigation__button"
          type="button"
          onClick={showRegionConfiguration}
        >
          {region.Code}
        </button>
      </div>
    </div>
  );
}

export default Navigation;
